'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import InvestorCountriesController from "./controller/investorCountries";
import InvestorCountryModalCreateController from "./controller/investorCountryModalCreate";
import InvestorCountryTableDirective from "./directive/investorCountryTable";
import InvestorCountryService from "./service/investorCountry";

export default angular.module('investmentProject.investorCountry', [])
    .controller('InvestorCountriesController', InvestorCountriesController)
    .controller('InvestorCountryModalCreateController', InvestorCountryModalCreateController)
    .directive('investorCountryTable', InvestorCountryTableDirective)
    .factory('InvestorCountryService', InvestorCountryService)
    .name;
